export enum AirportCodeEnum {
    MIAMI_AIRPORT = 195982,
    CANCUN_AIRPORT = 193176,
    ORLANDO_AIRPORT = 196835,
    DEFAULT_AIRPORT = 0
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/airport-code.enum.ts